import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { AbstractCreateEntityComponent } from '@abstracts/entities/create-entity';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, Injector, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { RfidCardsService } from '@services/entity/rfidCards.service';
import { UsersService } from '@services/entity/users.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-agb',
  templateUrl: './agb.component.html',
  styleUrls: ['./agb.component.scss']
})
export class AGBComponent extends AbstractDialogContent implements OnInit {

  public className = 'AGBComponent';

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  constructor(
    public activeModal: NgbActiveModal,
    private rfidCardService: RfidCardsService,
    private usersService: UsersService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  createForm() {

  }

  onSubmit(formValue) {
  }
}
